import React from 'react'
import DatePicker from "react-datepicker";
import { createPortal } from "react-dom";

import "react-datepicker/dist/react-datepicker.css";


function renderCalendarInBody({ children }) {
    if (typeof document === "undefined") {
        return children;
    }
    return createPortal(children, document.body);
}

function CustomeDatepicker({ selectedDate, onChangeDate, includeDates, placeholder }) {
    return (
        <DatePicker
            selected={selectedDate}
            onChange={onChangeDate}
            includeDates={[ ...includeDates.map((item) => item.date) ]}
            placeholderText={placeholder}
            dateFormat="dd/MM/yyyy"
            className="date-picker-custom-v1"
            popperContainer={renderCalendarInBody}
            popperProps={{ strategy: "fixed" }}
        />
    )
}

export default CustomeDatepicker